import React, { useState, useEffect } from "react";
import { newsService } from "../services/api";
export default function NewsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: "", content: "", post_type: "news", status: "published" });
  const [submitting, setSubmitting] = useState(false);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    loadPosts();
    newsService.getCategories().then(r => setCategories(r.data)).catch(() => {});
  }, []);
  const loadPosts = () => {
    setLoading(true);
    newsService.getPosts({ per_page: 50 }).then(r => { setPosts(r.data.results || []); setLoading(false); }).catch(() => setLoading(false));
  };
  const handleCreate = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await newsService.createPost(form);
      setForm({ title: "", content: "", post_type: "news", status: "published" });
      setShowForm(false);
      loadPosts();
    } catch (err) {
      const detail = err.response
        ? `Erreur ${err.response.status}: ${JSON.stringify(err.response.data)}`
        : `Erreur reseau: ${err.message}`;
      alert(detail);
    }
    finally { setSubmitting(false); }
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cet article ?")) return;
    try { await newsService.deletePost(id); loadPosts(); } catch { alert("Erreur"); }
  };
  const typeColors = { news: "#1A5C2A", event: "#1565C0", announcement: "#E65100", poll: "#6A1B9A" };
  const typeLabels = { news: "Actualité", event: "Événement", announcement: "Annonce", poll: "Sondage" };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Actualités</h1>
          <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{posts.length} publications</p>
        </div>
        <button onClick={() => setShowForm(!showForm)}
          style={{ background: "linear-gradient(135deg, #0F3D1A, #1A5C2A)", color: "white", border: "none", padding: "12px 24px", borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "Poppins" }}>
          + Nouvelle publication
        </button>
      </div>
      {showForm && (
        <div style={{ background: "white", borderRadius: 20, padding: 28, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
          <h3 style={{ color: "#1A1A2E", fontSize: 16, fontWeight: 700, margin: "0 0 20px" }}>Nouvelle publication</h3>
          <form onSubmit={handleCreate}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Type</label>
                <select value={form.post_type} onChange={e => setForm({...form, post_type: e.target.value})}
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none" }}>
                  <option value="news">Actualité</option>
                  <option value="event">Événement</option>
                  <option value="announcement">Annonce</option>
                  <option value="poll">Sondage</option>
                </select>
              </div>
              <div>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Statut</label>
                <select value={form.status} onChange={e => setForm({...form, status: e.target.value})}
                  style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none" }}>
                  <option value="published">Publié</option>
                  <option value="draft">Brouillon</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Titre *</label>
              <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} required placeholder="Titre de la publication..."
                style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Contenu *</label>
              <textarea value={form.content} onChange={e => setForm({...form, content: e.target.value})} required rows={6} placeholder="Contenu de la publication..."
                style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <button type="submit" disabled={submitting}
                style={{ background: "#1A5C2A", color: "white", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: submitting ? "not-allowed" : "pointer", fontFamily: "Poppins" }}>
                {submitting ? "Publication..." : "Publier"}
              </button>
              <button type="button" onClick={() => setShowForm(false)}
                style={{ background: "#F5F6FA", color: "#8A8A9A", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "Poppins" }}>
                Annuler
              </button>
            </div>
          </form>
        </div>
      )}
      {loading ? <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Chargement...</div> : (
        <div style={{ display: "grid", gap: 14 }}>
          {posts.map(post => (
            <div key={post.id} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <span style={{ background: (typeColors[post.post_type] || "#1A5C2A") + "20", color: typeColors[post.post_type] || "#1A5C2A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>
                    {typeLabels[post.post_type] || post.post_type}
                  </span>
                  <span style={{ background: post.status === "published" ? "#1A5C2A20" : "#8A8A9A20", color: post.status === "published" ? "#1A5C2A" : "#8A8A9A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 600 }}>
                    {post.status === "published" ? "Publié" : "Brouillon"}
                  </span>
                </div>
                <h3 style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700, color: "#1A1A2E" }}>{post.title}</h3>
                <p style={{ margin: 0, fontSize: 13, color: "#8A8A9A" }}>{post.content?.substring(0, 100)}...</p>
                <p style={{ margin: "8px 0 0", fontSize: 11, color: "#8A8A9A" }}>👁 {post.views_count} vues • ❤️ {post.likes_count} likes • 💬 {post.comments_count} commentaires</p>
              </div>
              <div style={{ display: "flex", gap: 8, marginLeft: 16 }}>
                <button onClick={() => handleDelete(post.id)}
                  style={{ background: "rgba(211,47,47,0.1)", color: "#D32F2F", border: "none", padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>
                  Supprimer
                </button>
              </div>
            </div>
          ))}
          {posts.length === 0 && <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Aucune publication. Créez votre première actualité!</div>}
        </div>
      )}
    </div>
  );
}